<template>
    <page-container2 :title="formTitle" useCard>
        <template v-slot:buttons>
            <el-button type="primary" size="mini" @click="save">保存</el-button>
        </template>
        <permission-container :permissionId="permissionId" showTip>
          <el-form ref="form" :model="form" v-loading="loading" status-icon :rules="rules" label-width="100px">
            <el-form-item label="产品名称" prop="name">
                <el-input v-model="form.name" autocomplete="off" class="one-third-width" placeholder="请输入产品名称" ></el-input>
            </el-form-item>
            <el-form-item label="产品编码" prop="code">
                <el-input v-model="form.code" autocomplete="off" class="one-third-width" placeholder="请输入产品编码" ></el-input>
            </el-form-item>
            <el-form-item label="产品备注" prop="remark">
                <el-input type="textarea" v-model="form.remark" class="half-width"
                          placeholder="请输入产品备注"
                          :rows="4"
                          maxlength="64"
                          show-word-limit
                ></el-input>
            </el-form-item>
            
          </el-form>
        </permission-container>
       
    </page-container2>
</template>

<script>
function isArrayItemEquals(arr1, arr2) {
    if(!arr1 || !arr2) return false;
    if(arr1.length != arr2.length) return false;
    for(let v of arr1) {
        if(!arr2.find((a2v)=>a2v==v)) {
            return false;
        }
    }
    return true;
}
export default {
    name: "ProductEdit",
    data()
    {
        return {
            form: {
                id: 0,
                name: '',
                code: '',
                remark: '',
            },
            rules: {
                name: [
                    { required: true, message: '请输入产品名称', trigger: 'blur' },
                ]
            },
            loading: false,
            permissionId: "Erp.Product.Add",
            formTitle: "添加产品",
        };
    },
    mounted()
    {
        // console.log('user edit mounted.', this.$route.query);
        return Fx.Promise.then(()=>
        {
            if(this.$route.query && this.$route.query.id)
            {
                this.permissionId = "Erp.Product.Edit";
                this.formTitle = "编辑产品";
                this.form.id = this.$route.query.id;
                return this.loadProduct();
            }
        });

    },
    methods: {
        loadProduct() {
            if(!this.form.id) return Fx.Promise.resolve(true);
            return Fx.Http.post("/product/get", {id: this.form.id}).
            then((response)=>
            {
                console.log('get resp', response);
                if(response.isSuccess())
                {
                    this.form.id = response.getData("id");
                    this.form.name = response.getData("name");
                    this.form.code = response.getData("code");
                    this.form.remark = response.getData("remark");
                    return true;
                } else {
                    this.showMessageError('加载产品数据失败：' + response.getErrorMessage());
                    return false;
                }
            });
        },
        
        
        save()
        {
            console.log(this.form);
            return new Promise((resolve, reject)=>{
                this.$refs.form.validate(valid =>
                {
                    if(!valid) {
                        resolve(false);
                        return;
                    }
                    this.loading = true;
                    let savePath = "/product/save";
                    return Fx.Http.post(savePath, Fx.mergeDeep(this.form)).
                    then((resp)=>
                    {
                        this.loading = false;
                        if(resp.isSuccess())
                        {
                            this.form.id = resp.getData('id');
                            this.showMessageSuccess('保存成功');
                            return this.loadProduct();
                        }
                        else
                        {
                            this.showMessageError('保存产品失败:'+resp.getErrorMessage());
                            return false;
                        }
                    }).
                    then(result=>resolve(result));
                });
            })
        },
        
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/modules/erp/pages/product/Edit.vue